// extracted by css-extract-rspack-plugin
export default {"root":"Button-module__root___QB3Fo","label":"Button-module__label___WzMo8","leftSection":"Button-module__leftSection___VVu1r","rightSection":"Button-module__rightSection___hpBqT"};